export default __webpack_public_path__ + "media/img/filetypes/xls-4ce81e61a135feb8a067ca65c4f18f2b.svg";